<script lang="ts">
    import CN from "classnames";

    export let height = "10px";
    export let width = "25%";
    export let rounded = false;
    export let pill = false;
</script>

<div
    class={CN("base-skeleton", {
        "base-skeleton__rounded": rounded,
        "base-skeleton__rounded-pill": pill,
    })}
    style="--height: {height}; --width: {width};"
/>

<style>
    .base-skeleton {
        height: var(--height);
        width: clamp(20px, var(--width), var(--width));
        background-color: #e2e8f0;
        display: inline-block;
        border-radius: 4px;
        position: relative;
        overflow: hidden;
    }

    .base-skeleton::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.2) 20%,
            rgba(255, 255, 255, 0.5) 60%,
            rgba(255, 255, 255, 0)
        );
        animation: shimmer 3s infinite;
        content: "";
    }

    .base-skeleton__rounded {
        border-radius: 100%;
    }

    .base-skeleton__rounded-pill {
        border-radius: 9999px;
    }

    @keyframes shimmer {
        100% {
            transform: translateX(100%);
        }
    }
</style>
